{
  "it": {
    "employee": {
      "actions": {
        "accessProjects": "Gestisci accesso ai progetti",
        "cancel": "Annulla",
        "changeProfilePicture": "Cambia immagine del profilo",
        "download": "Scarica",
        "new": "Membro del team",
        "profilePictureFormat": "Deve avere una dimensione minima di 300x300px",
        "save": "Salva",
        "searchEmployee": "Cerca membro del team",
        "sendinvitation": "Crea e invia invito",
        "submit": "Salva",
        "undoChanges": "Annulla"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Una volta al giorno (verso mezzogiorno)",
          "hourly": "Ogni ora",
          "twice_daily": "Due volte al giorno (mattina/mezzogiorno)",
          "weekly": "Una volta a settimana (lunedì a mezzogiorno)"
        },
        "first_name": "Nome",
        "language": "Lingua",
        "last_name": "Cognome",
        "phone_landline": "Numero fisso",
        "phone_mobile": "Numero di cellulare",
        "profession": "Qualifica professionale",
        "role": "Diritti di accesso",
        "signature_html": "Firma della conversazione",
        "status": "Stato",
        "title": "Titolo"
      },
      "billing": {
        "contact_us": "Contattaci",
        "contact_us_message": "Ciao, vorrei modificare il pacchetto di {client_name}.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} in uso",
        "manage_members": "Gestisci membri",
        "package": "Pacchetto",
        "package_help_mup": "Cerca progetti o spazio di archiviazione in più, o vuole cambiare piano?",
        "package_help_sup": "Cerca progetti, posti o spazio di archiviazione in più, o vuole cambiare piano?",
        "plan_renamed": "Abbiamo introdotto nuovi piani, quindi il nome mostrato qui potrebbe non corrispondere al Suo abbonamento attuale. Ci contatti per saperne di più sui nuovi piani.",
        "projects": "Progetti",
        "projects_available": "Tutti i progetti in uso | 1 progetto disponibile | {count} progetti disponibili",
        "seats": "Posti",
        "seats_active": "/ {total} attivi",
        "seats_package": "Nessun posto nel Suo pacchetto | 1 posto nel Suo pacchetto | {count} posti nel Suo pacchetto",
        "seats_paying": "+ 1 posto extra a pagamento | + {count} posti extra a pagamento",
        "storage": "Archiviazione",
        "storage_available": "{amount} GB disponibili",
        "storage_total": "/ {amount} GB",
        "units": "Unità",
        "units_available": "Tutte le unità in uso | 1 unità disponibile | {count} unità disponibili"
      },
      "integrations": {
        "hide_details": "Nascondi dettagli",
        "last_synced_at": "Ultima sincronizzazione: {time}",
        "show_details": "Mostra dettagli"
      },
      "labels": {
        "all_projects": "Tutti i progetti",
        "confirmPasswordReset": "È stata inviata un'email con un link per reimpostare la password; controlli la Sua casella di posta. Ci contatti se riscontra problemi.",
        "disabled": {
          "access": "Concederemo a tutti i dipendenti l'accesso alla piattaforma non appena l'ultima fattura scaduta sarà stata pagata.",
          "contact": "Ci contatti",
          "overdue": "Abbiamo notato che l'ultima fattura è scaduta da tempo. Abbiamo revocato l'accesso alla piattaforma per tutti i dipendenti. Partner e clienti potranno comunque accedere ai propri dati.",
          "title": "Il Suo account è stato disabilitato."
        },
        "display": "Visualizzazione",
        "filters": "Filtri",
        "generalNotifications": "Riceva notifiche su",
        "has_access_to": "Ha accesso a",
        "information": "Informazioni del profilo",
        "informationNotificationsEmail": "Riceva una panoramica via email, che include solo le notifiche che non ha ancora visto sulla piattaforma.",
        "informationNotificationsPlatform": "Riceva tutte le notifiche nella Sua panoramica personale in alto a destra dello schermo",
        "informationNotificationsTitle": "Decida quali notifiche desidera ricevere e in che modo",
        "its_you!": "È Lei.",
        "maintainerAccess": "Accesso concesso per progetto.",
        "name": "Nome",
        "onPlatform": "Sulla piattaforma",
        "ownerAccess": "Accesso a tutti i progetti e contenuti, più la fatturazione e la gestione del team.",
        "password": "Password",
        "permissions": "Diritti di accesso per",
        "permissionsOwnerOnly": "Come Gestore di progetto non può eseguire questa azione. Chieda a un membro del team di {client_name} con ruolo Proprietario di farlo per Lei.",
        "projectMaintains": "{first_name} ha accesso ai seguenti progetti:",
        "projectMaintainsAdd": "Per concedere l'accesso, selezioni un progetto e aggiunga {first_name} come Gestore di progetto nella funzione Informazioni.",
        "projectMaintainsNone": "non ha accesso ad alcun progetto.",
        "projectNotifications": "Per il progetto",
        "search_by_name_or_email": "Cerca per nome o email",
        "show_signature": "Mostra firma",
        "signature_active": "Firma attiva",
        "signature_info": "Questa firma verrà aggiunta alle risposte inviate a clienti e partner.",
        "sorting": "Ordinamento",
        "viaEmail": "Via email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accessibile",
          "description": "Le modifiche vengono salvate automaticamente",
          "not_accessible": "Non accessibile",
          "title": "Aggiorna l'accessibilità del progetto per {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Gestore",
        "owner": "Proprietario"
      },
      "team": {
        "actions": {
          "activate": "Attiva",
          "cancel_invitation": "Annulla invito",
          "deactivate": "Disattiva",
          "invite": "Invita",
          "make_maintainer": "Rendi gestore",
          "make_owner": "Rendi proprietario",
          "remove": "Rimuovi dal team"
        },
        "dialogs": {
          "activate_body": "{name} riottiene l'accesso completo alla piattaforma.",
          "activate_body_pending": "{name} torna In attesa e diventa attivo quando accede con il suo invito.",
          "activate_body_seat": "{name} riottiene l'accesso completo alla piattaforma. Questo usa un posto.",
          "activate_confirm": "Attiva",
          "activate_title": "Attivare {name}?",
          "cancel_invitation_body": "{name} non potrà più unirsi con l'invito ricevuto.",
          "cancel_invitation_confirm": "Annulla invito",
          "cancel_invitation_title": "Annullare l'invito?",
          "contact_us": "Contattaci",
          "contact_us_message": "Ciao, vorrei aggiungere altri posti per {client_name}.",
          "deactivate_body": "{name} mantiene l'account ma perde l'accesso alla piattaforma.",
          "deactivate_body_seat": "{name} mantiene l'account ma perde l'accesso alla piattaforma. Questo libera un posto.",
          "deactivate_confirm": "Disattiva",
          "deactivate_title": "Disattivare {name}?",
          "demote_body": "{name} perde l'accesso a tutti i progetti finché non glieli assegna, e non può più gestire la fatturazione né il team.",
          "demote_confirm": "Rendi gestore",
          "demote_title": "Rendere {name} gestore?",
          "owner_wall_banner": "La Sua organizzazione deve sempre avere almeno un proprietario attivo.",
          "owner_wall_body_deactivate": "Riattivi o promuova un altro proprietario prima di disattivare {name}.",
          "owner_wall_body_demote": "Riattivi o promuova un altro proprietario prima di cambiare il ruolo di {name}.",
          "owner_wall_body_remove": "Riattivi o promuova un altro proprietario prima di rimuovere {name}.",
          "owner_wall_title": "Azione bloccata",
          "promote_body": "{name} ottiene l'accesso a tutti i progetti e può gestire la fatturazione e il team.",
          "promote_confirm": "Rendi proprietario",
          "promote_title": "Rendere {name} proprietario?",
          "remove_body": "{name} perde l'accesso ed esce dall'elenco dei membri. Non si può annullare, ma potrà invitarlo di nuovo più tardi.",
          "remove_body_seat": "{name} perde l'accesso ed esce dall'elenco dei membri. Non si può annullare, ma potrà invitarlo di nuovo più tardi. Questo libera un posto.",
          "remove_confirm": "Rimuovi",
          "remove_title": "Rimuovere {name} dal team?",
          "seats_full_banner": "Il Suo unico posto è in uso. | Tutti i {total} posti sono in uso.",
          "seats_full_body": "Disattivi un membro attivo per liberare un posto, o ci contatti per aggiungere altri posti.",
          "seats_full_invite_body": "Le serve un posto disponibile per invitare qualcuno. Disattivi un membro attivo, o ci contatti per aggiungere altri posti.",
          "seats_full_invite_title": "Ha esaurito i posti",
          "seats_full_title": "Nessun posto disponibile"
        },
        "invite_incomplete": "Compila nome, cognome ed e-mail per inviare l'invito.",
        "invite_note": "Diventano attivi appena creano un account e accedono.",
        "invite_note_seats": "Appena creano un account e accedono diventano attivi, usando il Suo ultimo posto disponibile. | Appena creano un account e accedono diventano attivi, usando uno dei Suoi {count} posti disponibili.",
        "invite_sent": "Invito inviato",
        "invited_at": "Invitato: {when}",
        "last_active": "Ultima attività",
        "manage_in_billing": "Gestisci in Fatturazione",
        "resend_wait": "Può inviare di nuovo l'invito 15 minuti dopo il precedente.",
        "role": "Ruolo",
        "seat_states": "Stati dei posti",
        "seat_states_help": {
          "active": "Accesso completo, usa un posto. Proprietari e gestori.",
          "inactive": "L'account esiste, nessun accesso alla piattaforma. Libera il posto.",
          "pending": "Invitato, ancora senza account. Non usa un posto."
        },
        "seat_usage": "Utilizzo dei posti",
        "seats_available": "Nessun posto disponibile - disattivi un membro o ci contatti | 1 posto disponibile | {count} posti disponibili",
        "seats_rule": "Solo un proprietario può attivare un membro, e solo finché c'è un posto disponibile.",
        "seats_total": "/ {total} posto attivo | / {total} posti attivi",
        "statuses": {
          "active": "Attivo",
          "inactive": "Inattivo",
          "pending": "In attesa"
        }
      },
      "toasts": {
        "create": "Membro del team creato",
        "update": "Membro del team aggiornato"
      },
      "validation": {
        "emailTaken": "L'indirizzo email è già stato utilizzato",
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "needFirstName": "Nome obbligatorio",
        "needLastName": "Cognome obbligatorio",
        "requireEmailAddress": "Email obbligatoria",
        "role": "Selezionare i diritti di accesso"
      }
    }
  }
}
